import {DEFAULT_LANGUAGE} from "@typesDef/profile.types";

export enum StreamFields {
    streamSource = "streamSource",
    streamTarget = "streamTarget"
}

export enum AssignmentStatus {
    pending = "pending", // default
    active = "active", // active assignment
    history = "history" // assignment is history
}

export const ASSIGNMENT_DEFAULT_STATUS = AssignmentStatus.pending;
export const ASSIGNMENT_STATUS: string[] = Object.values(AssignmentStatus);

export enum AssignmentMode {
    split = "split",
    duplex = "duplex"
}
export const ASSIGNMENT_DEFAULT_MODE = AssignmentMode.split;
export const ASSIGNMENT_MODES: string[] = Object.values(AssignmentMode);


export enum StreamingProtocol {
    auto = "auto", // auto / default
    srt = "srt",
    rtmp = "rtmp",
    webrtc = "webrtc",
    hls = "hls",
    dash = "dash",
    other = "other"
}
export const ASSIGNMENT_DEFAULT_PROTOCOL = StreamingProtocol.auto;
export const ASSIGNMENT_PROTOCOLS: string[] = Object.values(StreamingProtocol);

export enum StreamingMedia {
    video = "video",
    audio = "audio",
    av = "av" // audio-video
}

export const ASSIGNMENT_DEFAULT_MEDIA = StreamingMedia.video;
export const ASSIGNMENT_MEDIA: string[] = Object.values(StreamingMedia);



export const ASSIGNMENT_DEFAULT_CHANNEL_LANGUAGE = DEFAULT_LANGUAGE;

